import { memo } from 'react'
import { CombinedSymbol, isSpotSymbol } from '../../utils/symbols'
import { Ether } from '../../types'
import { useCurrencyMarkPrice } from '../../hooks/perp/useCurrencyMarkPrice'
import { TooltipText } from '../TooltipText'
import { toFixed } from '../../utils/number'
import { styled } from '@mui/material'

const MarkPrice = styled('span')`
  font-size: 12px;
  line-height: 18px;
  margin-left: 12px;
  cursor: pointer;
  color: ${(props) => props.theme.color.text50};
  user-select: none;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const OrderbookMarkPrice = memo<{
  symbol: Partial<CombinedSymbol>
  callbackMarkPrice: (price: Ether) => void
}>(({ symbol, callbackMarkPrice }) => {
  const { baseCurrency = '', quoteScale = 0 } = symbol
  const markPrice = useCurrencyMarkPrice(baseCurrency)

  const isSpot = isSpotSymbol(symbol)

  if (isSpot) return null

  return (
    <MarkPrice onClick={() => callbackMarkPrice(markPrice)}>
      <TooltipText
        sx={{ cursor: 'pointer' }}
        title="Current Mark Price"
        placement="top"
      >
        ${toFixed(markPrice, quoteScale, { fixed: true })}
      </TooltipText>
    </MarkPrice>
  )
})
